<template>

    <svg id="Button-Phone" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 30 30" :style="{ transform: flip ? 'rotate(180deg)' : '' }" @click="$emit('click')" class="tw-cursor-pointer">
        <g id="Button" transform="translate(0 0)">
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="15" cy="15" r="15" transform="translate(0 0)" :fill="fill" />
            <g id="Group_1257" data-name="Group 1257" transform="translate(13.125 20.319) rotate(-90)">
                <path id="Path_352" data-name="Path 352" d="M0,0,5.728,5.728,11.456,0" transform="translate(0)" fill="none" stroke="#27eaa8" stroke-width="1"/>
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: 'SolidBlackArrows',
    props: {
        size: {
            type: Number,
            default: 30
        },
        fill: {
            type: String,
            default: "#231f20"
        },
        stroke: {
            type: String,
            default: "#000"
        },
        flip: {
            type: Boolean,
            default: false
        }
    }
};
</script>
